import { useEffect, useState } from 'react';
import { ApiError, get } from './api';
import { Modal } from './ui';

/**
 * "Attendance" on the Employees page (owner 10/22): late arrivals, leaving early, call-outs and slow-day cuts in the
 * last 60 days, each group on its own, newest first. Slow cuts are the store's choice, so they never count against
 * the person; they're listed so managers can share them out fairly.
 */
interface Item { id: number; date: string; label: string; kind: string; group: 'late' | 'out' | 'slow'; what: string; reason: string; store: string; by: string | null }

const GROUPS: Array<{ key: Item['group']; title: string; note: string; cls: string }> = [
  { key: 'late', title: 'Late or left early', note: 'Their own reasons (Sick, Personal, Injury).', cls: 'attg late' },
  { key: 'out', title: 'Called out', note: 'Missed the whole shift. Not counting shifts the store cancelled for slow.', cls: 'attg out' },
  { key: 'slow', title: 'Cut for slow', note: 'The store asked them: sent home early, asked to start later, or shift cancelled. Doesn’t count against them; it’s here so slow-day cuts can be shared out fairly.', cls: 'attg slow' },
];

export function AttendanceModal({ employeeId, onClose }: { employeeId: number; onClose: () => void }) {
  const [d, setD] = useState<{ name: string; items: Item[] } | null>(null);
  const [err, setErr] = useState('');
  useEffect(() => { void (async () => {
    try { setD(await get(`/api/employees/${employeeId}/attendance`)); } catch (e) { setErr(e instanceof ApiError ? e.message : 'Can’t load attendance.'); }
  })(); }, [employeeId]);
  return (
    <Modal title={d ? `${d.name} · attendance, last 60 days` : 'Attendance'} onClose={onClose} wide>
      {err && <div className="errbar">{err}</div>}
      {d && !d.items.length && <div className="stnone">Nothing in the last 60 days: no late arrivals, leaving early, call-outs or slow cuts.</div>}
      {d && d.items.length > 0 && GROUPS.map((g) => {
        const xs = d.items.filter((i) => i.group === g.key);
        return (
          <div key={g.key} className={g.cls}>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, flexWrap: 'wrap' }}><b>{g.title}</b><span className="attcount">{xs.length}×</span><span style={{ fontSize: 12.5, color: '#4A5561' }}>{g.note}</span></div>
            {xs.length ? (
              <table className="tbl" style={{ marginTop: 4 }}>
                <thead><tr><th>Day</th><th>What happened</th><th>Reason</th><th>Store</th><th>Marked by</th></tr></thead>
                <tbody>{xs.map((i) => <tr key={i.id}><td style={{ whiteSpace: 'nowrap' }}>{i.label}</td><td>{i.what}</td><td>{i.reason}</td><td>{i.store}</td><td style={{ color: '#4A5561' }}>{i.by ?? '—'}</td></tr>)}</tbody>
              </table>
            ) : <div className="stnone" style={{ marginTop: 2 }}>None.</div>}
          </div>
        );
      })}
      <div style={{ fontSize: 12, color: '#4A5561' }}>From mid-day changes on the day board. Changes that were undone aren’t counted.</div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}><button className="tbtn primary" style={{ minWidth: 90 }} onClick={onClose}>Done</button></div>
    </Modal>
  );
}
